import { render, staticRenderFns } from "./ImportCreditDialog.vue?vue&type=template&id=2b2c7cc0&scoped=true&"
import script from "./ImportCreditDialog.vue?vue&type=script&lang=js&"
export * from "./ImportCreditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImportCreditDialog.vue?vue&type=style&index=0&id=2b2c7cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c7cc0",
  null
  
)

export default component.exports